

type Props = {};

const SystemHealth = (props: Props) => {
  return (
    <div className="mt-4 overflow-y-auto">
      {/* Inlet */}
      <div className="d-flex align-items-center justify-content-between">
        <h4>SystemHealth</h4>
      </div>
    </div>
  );
};

export default SystemHealth;
